const config = {
    initialColorMode: "system",
    useSystemColorMode: true
  };
  
  export default config;